import React, { useEffect, useState } from 'react'
import { Mention, MentionsInput } from 'react-mentions'
import mentionsInputStyle from './mentionsInputStyle'

const Editor = ({
    onChange,
    onClick,
    memberList = [],
    value,
    addClass,
    isMarkToolRelease
}) => {
    const [users, setUsers] = useState([])

    useEffect(() => {
        const tmpArray = []
        for (const item of memberList) {
            tmpArray.push({
                id: item.memberId,
                display: item.value
            })
        }
        setUsers(tmpArray)
    }, [memberList])

    const handleObjectCopy = (e) => {
        const key = e.which || e.keyCode
        if (key === 86 && (e.ctrlKey || e.metaKey)) {
            e.preventDefault()
            navigator.clipboard.readText().then((res) => {
                const txtElement = document.getElementsByClassName(
                    'editor-mention__input'
                )
                const cloneMessage = value
                const position = txtElement[0].selectionStart
                const output = [
                    cloneMessage.slice(0, position),
                    res,
                    cloneMessage.slice(position)
                ].join('')
                onChange(output)
            })
        }
    }

    useEffect(() => {
        // document.addEventListener('keydown', handleObjectCopy)
        //
        // return () => {
        //     document.removeEventListener('keydown', handleObjectCopy)
        // }
    }, [isMarkToolRelease, value])

    return (
        <div className={`w-100 ${addClass ? 'toggle-height' : ''}`}>
            <MentionsInput
                placeholder='Use @ to mention'
                value={value}
                onChange={(e) => onChange(e.target.value)}
                a11ySuggestionsListLabel='Suggested mentions'
                style={mentionsInputStyle}
                className='editor-mention'
                onClick={onClick}
            >
                <Mention
                    style={{ backgroundColor: '#d3e1eb' }}
                    data={users}
                    markup='@@@____id__^^____display__@@@^^^'
                />
            </MentionsInput>
        </div>
    )
}

export default Editor
